import { createContext } from "react";

export const MenuContext = createContext(null);
